import AlphaYearsFilter from '@app/shared/filters/types/alpha-years.component';
import AppFilter from '@app/shared/filters/types/app.component';
import CourseFilter from '@app/shared/filters/types/course.component';
import GradeLevelFilter from '@app/shared/filters/types/grade-level.component';
import GuideFilter from '@app/shared/filters/types/guides.component';
import LevelFilter from '@app/shared/filters/types/level.component';
import MapFilter from '@app/shared/filters/types/map.component';
import NIAppFilter from '@app/shared/filters/types/non-integrated-app.component';
import NICourseFilter from '@app/shared/filters/types/non-integrated-course.component';
import NMSubjectFilter from '@app/shared/filters/types/non-map-subject.component';
import SeasonFilter from '@app/shared/filters/types/season.component';
import SessionFilter from '@app/shared/filters/types/session.component';
import StudentFilter from '@app/shared/filters/types/student.component';
import SubjectFilter from '@app/shared/filters/types/subject.component';
import WeekFilter from '@app/shared/filters/types/week.component';
import ScoreFilter from '@app/shared/filters/types/score.component';

import {Indexable} from '@app/shared/models/indexable.model';

/**
 * This class is used to map Filter IDs to their respective components.
 * It is required by the Sub Header component which dynamically loads filters
 * based on provided array of enabled Filter IDs.
 *
 * Please note that the name of the static method must align to ComponentID registered
 * in Filter Type class as it is used to query components.
 */
export default class FilterMap {
  public static AlphaYears          = AlphaYearsFilter;
  public static App                 = AppFilter;
  public static Course              = CourseFilter;
  public static Grade               = GradeLevelFilter;
  public static Guide               = GuideFilter;
  public static Level               = LevelFilter;
  public static Map                 = MapFilter;
  public static NonIntegratedApp    = NIAppFilter;
  public static NonIntegratedCourse = NICourseFilter;
  public static NonMapSubject       = NMSubjectFilter;
  public static Season              = SeasonFilter;
  public static Session             = SessionFilter;
  public static Student             = StudentFilter;
  public static Subject             = SubjectFilter;
  public static Week                = WeekFilter;
  public static Score                 = ScoreFilter;

  public static get(componentId: string): any {
    return (
      FilterMap as Indexable
    )[componentId];
  }
}
